import { z } from 'zod';

export const urlPreviewSchema = z.object({
  title: z.string().nullable(),
  description: z.string().nullable(),
  image: z.string().nullable(),
  favicon: z.string().nullable(),
  /**
   * Whether the target allows being embedded in an iframe by us. Determined
   * server-side from `X-Frame-Options` and `Content-Security-Policy:
   * frame-ancestors` on the page response. `false` means the client should
   * skip the iframe preview and show OG metadata only — otherwise we'd
   * render Chrome's `chrome-error://chromewebdata/` page and spew console
   * errors about cross-origin sub-resources.
   */
  embeddable: z.boolean().default(false),
});
export type UrlPreview = z.infer<typeof urlPreviewSchema>;
